import React from 'react';
import MenuItem from './MenuItem';
import Submenu from './Submenu';
import PatientList from './PatientList';

export const renderMenuItems = (
  items,
  userType,
  selectedMenuKey,
  handleMenuClick,
  isDrawerExpanded,
  isNewMesage,
  isHovering
) => {
  return items.map((item, index) => {
    const isSelected =
      (localStorage.getItem('selectedMenuKey') || selectedMenuKey) ===
      (item.key || item.name);

    // Check if the item is collapsible and has a submenu
    if (item?.collapsible && item?.submenu?.length > 0) {
      return (
        <Submenu
          key={index}
          isSelected={isSelected}
          item={item}
          isDrawerExpanded={isDrawerExpanded}
          isHovering={isHovering}
        />
      );
    }

    // Only render PatientList if both conditions are true:
    // 1. User is a DOCTOR or TEACHER
    // 2. Item has collapsible property
    if (
      (userType === 'DOCTOR' || userType === 'TEACHER') &&
      item?.collapsible
    ) {
      return (
        <PatientList
          key={index}
          icon={item.icon}
          text={item.name}
          isDrawerExpanded={isDrawerExpanded}
          isHovering={isHovering}
        />
      );
    }

    // For non-DOCTOR users or non-collapsible items, render regular MenuItem
    // Only render if the item doesn't have collapsible property
    if (!item?.collapsible) {
      return (
        <MenuItem
          key={index}
          item={item}
          isSelected={isSelected}
          onClick={() => handleMenuClick(item)}
          isDrawerExpanded={isDrawerExpanded}
          isNewMessage={isNewMesage}
          isHovering={isHovering}
        />
      );
    }

    return null; // Don't render anything for collapsible items for non-DOCTOR users
  });
}; 